import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode } from "vue";
import _imports_0 from '@/assets/images/eth_address.webp';
const _hoisted_1 = {
  class: "pt-5 pb-5"
};
const _hoisted_2 = {
  class: "container"
};
const _hoisted_3 = {
  class: "row"
};
const _hoisted_4 = {
  class: "col-lg-8"
};
const _hoisted_5 = {
  class: "bg-white p-30",
  style: {
    "border-radius": "10px",
    "box-shadow": "0px 4px 24px 0px rgb(16 27 82 / 8%)"
  }
};
const _hoisted_6 = {
  class: "mb-4"
};
const _hoisted_7 = {
  href: "#/vote",
  class: "text-decoration-none"
};
const _hoisted_8 = {
  class: "mb-4"
};
const _hoisted_9 = {
  class: "fw-extra-bold"
};
const _hoisted_10 = {
  class: "mb-2"
};
const _hoisted_11 = {
  class: "mb-4 fw-medium"
};
const _hoisted_12 = {
  key: 0,
  class: "w-100",
  style: {
    "height": "20px"
  }
};
const _hoisted_13 = {
  key: 1,
  class: "p-30 mt-5 mb-5 bg-white",
  style: {
    "border-radius": "10px",
    "box-shadow": "0px 4px 24px 0px rgb(16 27 82 / 8%)"
  }
};
const _hoisted_14 = {
  class: "font-weight-bold h4 mb-4"
};
const _hoisted_15 = {
  class: "d-flex flex-column"
};
const _hoisted_16 = ["onClick"];
const _hoisted_17 = ["disabled"];
const _hoisted_18 = {
  key: 0,
  class: "spinner-border spinner-border-sm mr-2",
  style: {
    "position": "relative",
    "bottom": "2px"
  },
  role: "status",
  "aria-hidden": "true"
};
const _hoisted_19 = /*#__PURE__*/_createElementVNode("input", {
  type: "button",
  id: "showVoteModeBtn",
  "data-toggle": "modal",
  "data-target": "#voteModal",
  style: {
    "display": "none",
    "width": "0",
    "height": "0"
  }
}, null, -1);
const _hoisted_20 = {
  class: "p-30 bg-white",
  style: {
    "border-radius": "10px",
    "box-shadow": "0px 4px 24px 0px rgb(16 27 82 / 8%)"
  }
};
const _hoisted_21 = {
  class: "font-weight-bold h4 mb-4"
};
const _hoisted_22 = {
  key: 0,
  class: "mt-3"
};
const _hoisted_23 = {
  class: "d-flex justify-content-center align-items-center text-black-800"
};
const _hoisted_24 = {
  class: "row mb-4"
};
const _hoisted_25 = {
  class: "col-4 col-lg-4 d-flex"
};
const _hoisted_26 = /*#__PURE__*/_createElementVNode("span", {
  class: "mr-1"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "rounded-circle shadow",
  style: {
    "width": "20px"
  },
  alt: ""
})], -1);
const _hoisted_27 = {
  class: "fw-medium"
};
const _hoisted_28 = {
  class: "col-4 col-lg-4 text-center fw-medium"
};
const _hoisted_29 = {
  class: "col-4 col-lg-4 text-right fw-medium d-flex justify-content-end align-items-center align-content-center"
};
const _hoisted_30 = {
  class: "mr-3"
};
const _hoisted_31 = ["onClick"];
const _hoisted_32 = /*#__PURE__*/_createElementVNode("path", {
  d: "M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8zm7.5-6.923c-.67.204-1.335.82-1.887 1.855A7.97 7.97 0 0 0 5.145 4H7.5V1.077zM4.09 4a9.267 9.267 0 0 1 .64-1.539 6.7 6.7 0 0 1 .597-.933A7.025 7.025 0 0 0 2.255 4H4.09zm-.582 3.5c.03-.877.138-1.718.312-2.5H1.674a6.958 6.958 0 0 0-.656 2.5h2.49zM4.847 5a12.5 12.5 0 0 0-.338 2.5H7.5V5H4.847zM8.5 5v2.5h2.99a12.495 12.495 0 0 0-.337-2.5H8.5zM4.51 8.5a12.5 12.5 0 0 0 .337 2.5H7.5V8.5H4.51zm3.99 0V11h2.653c.187-.765.306-1.608.338-2.5H8.5zM5.145 12c.138.386.295.744.468 1.068.552 1.035 1.218 1.65 1.887 1.855V12H5.145zm.182 2.472a6.696 6.696 0 0 1-.597-.933A9.268 9.268 0 0 1 4.09 12H2.255a7.024 7.024 0 0 0 3.072 2.472zM3.82 11a13.652 13.652 0 0 1-.312-2.5h-2.49c.062.89.291 1.733.656 2.5H3.82zm6.853 3.472A7.024 7.024 0 0 0 13.745 12H11.91a9.27 9.27 0 0 1-.64 1.539 6.688 6.688 0 0 1-.597.933zM8.5 12v2.923c.67-.204 1.335-.82 1.887-1.855.173-.324.33-.682.468-1.068H8.5zm3.68-1h2.146c.365-.767.594-1.61.656-2.5h-2.49a13.65 13.65 0 0 1-.312 2.5zm2.802-3.5a6.959 6.959 0 0 0-.656-2.5H12.18c.174.782.282 1.623.312 2.5h2.49zM11.27 2.461c.247.464.462.98.64 1.539h1.835a7.024 7.024 0 0 0-3.072-2.472c.218.284.418.598.597.933zM10.855 4a7.966 7.966 0 0 0-.468-1.068C9.835 1.897 9.17 1.282 8.5 1.077V4h2.355z"
}, null, -1);
const _hoisted_33 = [_hoisted_32];
const _hoisted_34 = /*#__PURE__*/_createElementVNode("input", {
  type: "button",
  style: {
    "display": "none",
    "width": "0",
    "height": "0"
  },
  id: "showVoteInfoModeBtn",
  "data-toggle": "modal",
  "data-target": "#voteInfoModal"
}, null, -1);
const _hoisted_35 = {
  class: "col-lg-4 mt-4 mt-lg-0"
};
const _hoisted_36 = {
  class: "container bg-white p-20",
  style: {
    "border-radius": "10px",
    "box-shadow": "0px 4px 24px 0px rgb(16 27 82 / 8%)"
  }
};
const _hoisted_37 = {
  class: "mb-2 h4 font-weight-bold"
};
const _hoisted_38 = {
  class: "row mb-1"
};
const _hoisted_39 = {
  class: "col-5 text-black-600 font-weight-bold"
};
const _hoisted_40 = {
  class: "col-7 text-right"
};
const _hoisted_41 = {
  class: "row mb-1"
};
const _hoisted_42 = {
  class: "col-5 text-black-600 font-weight-bold"
};
const _hoisted_43 = {
  class: "row mb-1"
};
const _hoisted_44 = {
  class: "col-5 text-black-600 font-weight-bold"
};
const _hoisted_45 = {
  class: "col-7 text-right"
};
const _hoisted_46 = {
  class: "row mb-1"
};
const _hoisted_47 = {
  class: "col-5 text-black-600 font-weight-bold"
};
const _hoisted_48 = /*#__PURE__*/_createElementVNode("div", {
  class: "col-7 text-right"
}, "单选投票", -1);
const _hoisted_49 = {
  class: "row mb-1"
};
const _hoisted_50 = {
  class: "col-5 text-black-600 font-weight-bold"
};
const _hoisted_51 = {
  class: "col-7 text-right"
};
const _hoisted_52 = {
  class: "row mb-1"
};
const _hoisted_53 = {
  class: "col-5 text-black-600 font-weight-bold"
};
const _hoisted_54 = {
  class: "col-7 text-right"
};
const _hoisted_55 = {
  class: "row mb-1"
};
const _hoisted_56 = {
  class: "col-5 text-black-600 font-weight-bold"
};
const _hoisted_57 = {
  class: "col-7 text-right"
};
const _hoisted_58 = {
  class: "container bg-white p-20 mt-4",
  style: {
    "border-radius": "10px",
    "box-shadow": "0px 4px 24px 0px rgb(16 27 82 / 8%)"
  }
};
const _hoisted_59 = {
  class: "mb-2 h4 font-weight-bold"
};
const _hoisted_60 = {
  class: "mb-1 font-weight-bold"
};
const _hoisted_61 = {
  class: "progress mb-1"
};
const _hoisted_62 = ["aria-valuenow"];
const _hoisted_63 = {
  class: "d-flex justify-content-between"
};
const _hoisted_64 = {
  class: "modal fade",
  ref: "voteModal",
  id: "voteModal",
  tabindex: "-1",
  "aria-labelledby": "voteModalLabel",
  "aria-hidden": "true"
};
const _hoisted_65 = {
  class: "modal-dialog modal-dialog-centered"
};
const _hoisted_66 = {
  class: "modal-content p-2"
};
const _hoisted_67 = {
  class: "modal-header",
  style: {
    "border-bottom": "none"
  }
};
const _hoisted_68 = {
  class: "fw-bold fsi-18 text-center",
  id: "voteModalLabel"
};
const _hoisted_69 = /*#__PURE__*/_createElementVNode("button", {
  id: "voteCloseModal",
  type: "button",
  class: "close",
  "data-dismiss": "modal",
  "aria-label": "Close"
}, [/*#__PURE__*/_createElementVNode("span", {
  "aria-hidden": "true"
}, "×")], -1);
const _hoisted_70 = {
  class: "modal-body"
};
const _hoisted_71 = {
  key: 0,
  class: "d-flex justify-content-center mb-4"
};
const _hoisted_72 = /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border",
  role: "status"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "sr-only"
}, "Loading...")], -1);
const _hoisted_73 = [_hoisted_72];
const _hoisted_74 = {
  key: 1,
  class: "alert",
  style: {
    "background-color": "rgb(242, 244, 246)"
  }
};
const _hoisted_75 = {
  class: "row align-items-center justify-content-between"
};
const _hoisted_76 = /*#__PURE__*/_createElementVNode("div", {
  class: "col-6 fsi-16 text-black-800"
}, "选项", -1);
const _hoisted_77 = {
  class: "col-6 text-right"
};
const _hoisted_78 = {
  class: "row align-items-center justify-content-between mt-2"
};
const _hoisted_79 = /*#__PURE__*/_createElementVNode("div", {
  class: "col-6 fsi-16 text-black-800"
}, "高度", -1);
const _hoisted_80 = {
  class: "col-6 text-right"
};
const _hoisted_81 = {
  class: "row align-items-center justify-content-between mt-2"
};
const _hoisted_82 = /*#__PURE__*/_createElementVNode("div", {
  class: "col-6 fsi-16 text-black-800"
}, "您的投票权", -1);
const _hoisted_83 = {
  class: "col-6 text-right"
};
const _hoisted_84 = {
  class: "d-flex justify-content-between w-100 mt-4"
};
const _hoisted_85 = /*#__PURE__*/_createElementVNode("div", {
  class: "col-6"
}, [/*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-dark btn-sm w-100",
  "data-dismiss": "modal",
  "aria-label": "Close"
}, "取消 ")], -1);
const _hoisted_86 = {
  class: "col-6"
};
const _hoisted_87 = ["disabled"];
const _hoisted_88 = {
  key: 0,
  class: "spinner-border spinner-border-sm mr-2",
  style: {
    "position": "relative",
    "bottom": "2px"
  },
  role: "status",
  "aria-hidden": "true"
};
const _hoisted_89 = {
  class: "modal fade",
  ref: "voteInfoModal",
  id: "voteInfoModal",
  tabindex: "-1",
  "aria-labelledby": "voteModalLabel",
  "aria-hidden": "true"
};
const _hoisted_90 = {
  class: "modal-dialog modal-dialog-centered"
};
const _hoisted_91 = {
  class: "modal-content p-2"
};
const _hoisted_92 = {
  class: "modal-header",
  style: {
    "border-bottom": "none"
  }
};
const _hoisted_93 = {
  class: "fw-bold fsi-18 text-center",
  id: "voteInfoModalLabel"
};
const _hoisted_94 = /*#__PURE__*/_createElementVNode("button", {
  id: "voteInfoCloseModal",
  type: "button",
  class: "close",
  "data-dismiss": "modal",
  "aria-label": "Close"
}, [/*#__PURE__*/_createElementVNode("span", {
  "aria-hidden": "true"
}, "×")], -1);
const _hoisted_95 = {
  class: "modal-body"
};
const _hoisted_96 = {
  class: "alert",
  style: {
    "background-color": "rgb(242, 244, 246)"
  }
};
const _hoisted_97 = {
  class: "row align-items-center justify-content-between"
};
const _hoisted_98 = /*#__PURE__*/_createElementVNode("div", {
  class: "col-6 fsi-16 text-black-800"
}, "IPFS", -1);
const _hoisted_99 = {
  class: "d-flex justify-content-between w-100 mt-4"
};
const _hoisted_100 = {
  class: "col-6"
};
const _hoisted_101 = {
  type: "button",
  class: "btn btn-dark btn-sm w-100",
  "data-dismiss": "modal",
  "aria-label": "Close"
};
const _hoisted_102 = {
  class: "col-6"
};
const _hoisted_103 = ["disabled"];
const _hoisted_104 = {
  key: 0,
  class: "spinner-border spinner-border-sm mr-2",
  style: {
    "position": "relative",
    "bottom": "2px"
  },
  role: "status",
  "aria-hidden": "true"
};
const _hoisted_105 = {
  key: 0,
  class: "ok-message-bottom"
};
const _hoisted_106 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "c",
  fill: "currentColor",
  class: "bi bi-check-circle-fill mr-2",
  viewBox: "0 0 16 16"
}, [/*#__PURE__*/_createElementVNode("path", {
  d: "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"
})], -1);
const _hoisted_107 = {
  key: 1,
  class: "fail-message-bottom"
};
const _hoisted_108 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  fill: "currentColor",
  class: "bi bi-dash-circle-fill mr-2",
  viewBox: "0 0 16 16"
}, [/*#__PURE__*/_createElementVNode("path", {
  d: "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM4.5 7.5a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1h-7z"
})], -1);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_components_loading = _resolveComponent("components-loading");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("a", _hoisted_7, _toDisplayString(_ctx.$t('vote.fanhui')), 1)]), _createElementVNode("div", _hoisted_8, [_createElementVNode("h3", _hoisted_9, _toDisplayString($options.detail.title), 1)]), _createElementVNode("div", _hoisted_10, [_createElementVNode("span", {
    class: _normalizeClass(["badge badge-pill", $data.proposalStatusMap[$options.detail.proposalStatus]?.className])
  }, _toDisplayString($data.proposalStatusMap[$options.detail.proposalStatus]?.label), 3)]), _createElementVNode("div", _hoisted_11, _toDisplayString($options.detail.body), 1)]), $options.detail.proposalStatus !== 'IMMEDIATELY' ? (_openBlock(), _createElementBlock("div", _hoisted_12)) : _createCommentVNode("", true), $options.detail.proposalStatus === 'IMMEDIATELY' ? (_openBlock(), _createElementBlock("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.$t('vote.touchunindepiao')), 1), _createElementVNode("div", _hoisted_15, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.detail?.choices, (choice, index) => {
    return _openBlock(), _createElementBlock("button", {
      type: "button",
      class: _normalizeClass(["btn btn-outline-primary mb-4", $data.voteSelectIndex === index ? 'select-btn-vote' : '']),
      onClick: $event => $options.voteSelect(index),
      key: index
    }, _toDisplayString(choice), 11, _hoisted_16);
  }), 128)), !$data.isConnected ? (_openBlock(), _createElementBlock("button", {
    key: 0,
    type: "button",
    class: "btn btn-primary",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.connectWallet && $options.connectWallet(...args))
  }, _toDisplayString(_ctx.$t('vote.lianjieqianbao')), 1)) : _createCommentVNode("", true), $data.isConnected ? (_openBlock(), _createElementBlock("button", {
    key: 1,
    type: "button",
    class: "btn btn-primary",
    onClick: _cache[1] || (_cache[1] = (...args) => $options.voteFun && $options.voteFun(...args)),
    disabled: $data.walletSignInfo.isLoading || $data.voteSelectIndex === -1
  }, [$data.walletSignInfo.isLoading ? (_openBlock(), _createElementBlock("span", _hoisted_18)) : _createCommentVNode("", true), _createElementVNode("span", null, _toDisplayString(_ctx.$t('vote.toupiao')), 1)], 8, _hoisted_17)) : _createCommentVNode("", true), _hoisted_19])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_20, [_createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.$t('vote.toupiaoshu')), 1), $data.loading ? (_openBlock(), _createBlock(_component_components_loading, {
    key: 0
  })) : _createCommentVNode("", true), !$data.loading ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 1
  }, [$options.voteList.records.length === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_22, [_createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.$t('vote.zangwutoupiaoshuju')), 1)])) : _createCommentVNode("", true), $options.voteList.records.length !== 0 ? (_openBlock(true), _createElementBlock(_Fragment, {
    key: 1
  }, _renderList($options.voteList.records, vote => {
    return _openBlock(), _createElementBlock("div", {
      class: "d-flex flex-column",
      key: vote.id
    }, [_createElementVNode("div", _hoisted_24, [_createElementVNode("div", _hoisted_25, [_hoisted_26, _createElementVNode("span", _hoisted_27, _toDisplayString($options.simpleAddress(vote.voter)), 1)]), _createElementVNode("div", _hoisted_28, _toDisplayString($options.detail?.choices[vote.choice - 1]), 1), _createElementVNode("div", _hoisted_29, [_createElementVNode("div", _hoisted_30, _toDisplayString(vote.vp) + " FDO", 1), (_openBlock(), _createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      onClick: $event => $options.showVoucher({
        ...vote
      }),
      width: "16",
      height: "16",
      fill: "currentColor",
      style: {
        "cursor": "pointer"
      },
      class: "bi bi-globe",
      viewBox: "0 0 16 16"
    }, _hoisted_33, 8, _hoisted_31)), _hoisted_34])])]);
  }), 128)) : _createCommentVNode("", true)], 64)) : _createCommentVNode("", true)])]), _createElementVNode("div", _hoisted_35, [_createElementVNode("div", _hoisted_36, [_createElementVNode("div", _hoisted_37, _toDisplayString(_ctx.$t('vote.xinxi')), 1), _createElementVNode("div", _hoisted_38, [_createElementVNode("div", _hoisted_39, _toDisplayString(_ctx.$t('vote.zhuangtai')), 1), _createElementVNode("div", _hoisted_40, _toDisplayString($data.proposalStatusMap[$options.detail?.proposalStatus].label), 1)]), _createElementVNode("div", _hoisted_41, [_createElementVNode("div", _hoisted_42, _toDisplayString(_ctx.$t('vote.biaoshifu')), 1), _createElementVNode("div", {
    class: "col-7 text-right cid-class",
    onClick: _cache[2] || (_cache[2] = $event => $options.gotoIpfs($options.detail.ipfs))
  }, _toDisplayString($options.simpleCid($options.detail.ipfs)), 1)]), _createElementVNode("div", _hoisted_43, [_createElementVNode("div", _hoisted_44, _toDisplayString(_ctx.$t('vote.gaodu')), 1), _createElementVNode("div", _hoisted_45, _toDisplayString($options.detail.blockNumber), 1)]), _createElementVNode("div", _hoisted_46, [_createElementVNode("div", _hoisted_47, _toDisplayString(_ctx.$t('vote.toupiaozhidu')), 1), _hoisted_48]), _createElementVNode("div", _hoisted_49, [_createElementVNode("div", _hoisted_50, _toDisplayString(_ctx.$t('vote.chaungjianshijian')), 1), _createElementVNode("div", _hoisted_51, _toDisplayString(new Date($options.detail.created).toLocaleString()), 1)]), _createElementVNode("div", _hoisted_52, [_createElementVNode("div", _hoisted_53, _toDisplayString(_ctx.$t('vote.kaishishijian')), 1), _createElementVNode("div", _hoisted_54, _toDisplayString(new Date($options.detail.start).toLocaleString()), 1)]), _createElementVNode("div", _hoisted_55, [_createElementVNode("div", _hoisted_56, _toDisplayString(_ctx.$t('vote.jieshushijian')), 1), _createElementVNode("div", _hoisted_57, _toDisplayString(new Date($options.detail.end).toLocaleString()), 1)])]), _createElementVNode("div", _hoisted_58, [_createElementVNode("div", _hoisted_59, _toDisplayString(_ctx.$t('vote.dangqianjieguo')), 1), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.voteResult, (voteRes, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "mb-4",
      key: index
    }, [_createElementVNode("div", _hoisted_60, _toDisplayString(voteRes.label), 1), _createElementVNode("div", _hoisted_61, [_createElementVNode("div", {
      class: "progress-bar",
      role: "progressbar",
      style: _normalizeStyle({
        width: `${parseFloat(voteRes.rate).toFixed(2)}%`
      }),
      "aria-valuenow": parseFloat(voteRes.rate).toFixed(2),
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }, null, 12, _hoisted_62)]), _createElementVNode("div", _hoisted_63, [_createElementVNode("div", null, _toDisplayString(voteRes.vp) + "   " + _toDisplayString(_ctx.$t('vote.zhangtoupiao')), 1), _createElementVNode("div", null, _toDisplayString(parseFloat(voteRes.rate).toFixed(2)) + "% ", 1)])]);
  }), 128))])])])]), _createElementVNode("div", _hoisted_64, [_createElementVNode("div", _hoisted_65, [_createElementVNode("div", _hoisted_66, [_createElementVNode("div", _hoisted_67, [_createElementVNode("div", _hoisted_68, _toDisplayString(_ctx.$t('vote.touchunindepiao')), 1), _hoisted_69]), _createElementVNode("div", _hoisted_70, [$data.loadingVoteCheckInfo ? (_openBlock(), _createElementBlock("div", _hoisted_71, _hoisted_73)) : _createCommentVNode("", true), !$data.loadingVoteCheckInfo ? (_openBlock(), _createElementBlock("div", _hoisted_74, [_createElementVNode("div", _hoisted_75, [_hoisted_76, _createElementVNode("div", _hoisted_77, _toDisplayString($options.detail.choices[$data.voteCheckInfo.choice - 1]), 1)]), _createElementVNode("div", _hoisted_78, [_hoisted_79, _createElementVNode("div", _hoisted_80, _toDisplayString($data.voteCheckInfo.blockNumber), 1)]), _createElementVNode("div", _hoisted_81, [_hoisted_82, _createElementVNode("div", _hoisted_83, _toDisplayString($data.voteCheckInfo.vp), 1)])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_84, [_hoisted_85, _createElementVNode("div", _hoisted_86, [_createElementVNode("button", {
    type: "button",
    class: "btn btn-primary btn-sm w-100",
    onClick: _cache[3] || (_cache[3] = (...args) => $options.subVote && $options.subVote(...args)),
    disabled: $data.walletSignInfo.isLoading
  }, [$data.walletSignInfo.isLoading ? (_openBlock(), _createElementBlock("span", _hoisted_88)) : _createCommentVNode("", true), _createTextVNode(" 确认 ")], 8, _hoisted_87)])])])])])], 512), _createElementVNode("div", _hoisted_89, [_createElementVNode("div", _hoisted_90, [_createElementVNode("div", _hoisted_91, [_createElementVNode("div", _hoisted_92, [_createElementVNode("div", _hoisted_93, _toDisplayString(_ctx.$t('vote.pingzheng')), 1), _hoisted_94]), _createElementVNode("div", _hoisted_95, [_createElementVNode("div", _hoisted_96, [_createElementVNode("div", _hoisted_97, [_hoisted_98, _createElementVNode("div", {
    class: "col-6 text-right cid-class",
    onClick: _cache[4] || (_cache[4] = $event => $options.gotoIpfs($data.showVoucherInfo.ipfs))
  }, _toDisplayString($options.simpleCid($data.showVoucherInfo.ipfs)), 1)])]), _createElementVNode("div", _hoisted_99, [_createElementVNode("div", _hoisted_100, [_createElementVNode("button", _hoisted_101, _toDisplayString(_ctx.$t('vote.quxiao')), 1)]), _createElementVNode("div", _hoisted_102, [_createElementVNode("button", {
    type: "button",
    class: "btn btn-primary btn-sm w-100",
    onClick: _cache[5] || (_cache[5] = $event => $options.goToSignatorIO($data.showVoucherInfo.ipfs)),
    disabled: $data.walletSignInfo.isLoading
  }, [$data.walletSignInfo.isLoading ? (_openBlock(), _createElementBlock("span", _hoisted_104)) : _createCommentVNode("", true), _createTextVNode(" " + _toDisplayString(_ctx.$t('vote.zaiyanzheng')), 1)], 8, _hoisted_103)])])])])])], 512), $data.voteResuleOk ? (_openBlock(), _createElementBlock("div", _hoisted_105, [_hoisted_106, _createTextVNode(" 投票成功 ")])) : _createCommentVNode("", true), $data.voteResuleFail ? (_openBlock(), _createElementBlock("div", _hoisted_107, [_hoisted_108, _createTextVNode(" " + _toDisplayString($data.voteResuleFailMes), 1)])) : _createCommentVNode("", true)]);
}